import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { subscribeToQueryData } from './crossTabQuerySync';

/**
 * Listens for query data shared by peer tabs and writes it into this tab's
 * QueryClient cache, so saving data in one tab updates the others without each
 * tab refetching. Mount once below the QueryClientProvider.
 */
export const useCrossTabQuerySync = (): void => {
  const queryClient = useQueryClient();

  useEffect(
    () => subscribeToQueryData((queryKey, data) => queryClient.setQueryData(queryKey, data)),
    [queryClient],
  );
};
